import React from 'react'
import { Cell } from 'react-mdl'
import './style.css'

import Item from '../item'

export default class Cube extends React.Component {

    state = {
        items: null
    }

    constructor(props) {
        super(props);

        props.data.cube.forEach((item) => {
            if (item.set_id !== undefined) {
                item.setInfo = props.data.setItems[item.set_id];
            }
        });

        this.state = {
            items: props.data.cube
        };
    }

    render() {
        return (
            <Cell className="cube-tab" col={6} tablet={12} phone={12}>
                <h3 className="tab-header">Cube</h3>
                <div className="cube-grid">
                    { this.state.items.map((item) =>
                        <Item key={`inv-${item.id}-pos-${item.x}-${item.y}`} data={item} />
                    )}
                </div>
            </Cell>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/cube/index.js